import React from 'react';
import { MiniDrawerWithContext } from 'components/Layout/drawer';
import { useTitle } from 'components/utilities/hooks/useTitle';
import { useAnnotationsPageStyles } from 'components/Annotations/styles';
import { Card } from 'components/TeamOverview/components/Common/Card/Card';
import { Box, Button, Pagination } from '@mui/material';
import { CardHeader } from 'components/UserProfile/components/CardHeader';
import { AnnotationItem } from 'components/AnnotaionItem/AnnotationItem';
import { useGetAnnotations } from 'components/Annotations/hooks';
import { useHistory, useLocation } from 'react-router';
import { useGetUrlParam } from 'components/SampleEditor/helpers/hooks';
import {
  PAGE_PARAM,
  PAGE_SIZE_PARAM,
} from 'components/SampleEditor/helpers/constants';
import { handleExportToExcel } from 'components/Annotations/utilities';
import Select from 'react-select';
import { PAGE_SIZES } from 'components/Annotations/constants';
import { Spinner } from 'components/Loading/Spinner/Spinner';

export const AnnotationsPage = () => {
  const history = useHistory();
  const currentPage = useGetUrlParam(PAGE_PARAM, 1);
  const pageSize = useGetUrlParam(PAGE_SIZE_PARAM, PAGE_SIZES[0].value);
  const { search } = useLocation();

  const { classes } = useAnnotationsPageStyles();
  useTitle('HistoWiz - Annotations');
  const { count, annotations, isLoading } = useGetAnnotations(
    currentPage,
    pageSize,
  );

  const pagesCount = Math.ceil(+count / +pageSize);

  const handlePageChange = (evt, value) => {
    const params = new URLSearchParams(search);
    params.set(PAGE_PARAM, value);

    history.replace({ search: params.toString() });
  };

  const handlePageSizeChange = (selectedOption) => {
    const params = new URLSearchParams(search);
    params.set(PAGE_SIZE_PARAM, selectedOption.value);
    params.set(PAGE_PARAM, 1);

    history.replace({ search: params.toString() });
  };

  // eslint-disable-next-line react/no-unstable-nested-components
  const PaginationSection = ({ placement = 'bottom' }) => (
    <>
      <Box width="6rem">
        <Select
          value={PAGE_SIZES.find((option) => option.value === +pageSize)}
          onChange={handlePageSizeChange}
          options={PAGE_SIZES}
          menuPlacement={placement}
        />
      </Box>
      <Pagination
        page={+currentPage}
        className={classes.pagination}
        count={pagesCount}
        variant="outlined"
        shape="rounded"
        onChange={handlePageChange}
      />
    </>
  );

  return (
    <MiniDrawerWithContext header="Annotations">
      <Box className={classes.paginationSection} marginBottom="1rem">
        <PaginationSection />
      </Box>
      <Card
        header={
          <Box className={classes.headerContainer}>
            <CardHeader
              title="ANNOTATIONS"
              subtitle="TEAM ANNOTATIONS"
              RightSection={
                <Button
                  onClick={() => handleExportToExcel(annotations, currentPage)}
                  variant="contained"
                  color="primary"
                  className={classes.exportButton}
                >
                  Export to Excel
                </Button>
              }
            />
          </Box>
        }
      >
        {isLoading ? (
          <Box className={classes.spinnerContainer}>
            <Spinner />
          </Box>
        ) : (
          <Box className={classes.ordersList}>
            {annotations?.map((annotation) => (
              <AnnotationItem key={annotation.uuid} {...annotation} />
            ))}
          </Box>
        )}
      </Card>
      <Box className={classes.paginationSection} marginTop="1rem">
        <PaginationSection placement="top" />
      </Box>
    </MiniDrawerWithContext>
  );
};
